// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"LoaderFundoTransparente_loaderOverlay__I3etq"};